import React from "react";

// Status → visual mapping. Warna: emerald=active, slate=inactive,
// amber=suspended, rose=archived (soft-deleted / dinonaktifkan permanen).
const STATUS_STYLE = {
  DRAFT: "bg-cyan-500/15 text-cyan-300 border-cyan-500/30",
  LAUNCHING: "bg-purple-500/15 text-purple-300 border-purple-500/30 animate-pulse",
  ONLINE: "bg-emerald-500/20 text-emerald-300 border-emerald-500/40",
  FAILED: "bg-rose-500/15 text-rose-300 border-rose-500/40",
  ACTIVE: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
  INACTIVE: "bg-slate-500/15 text-slate-300 border-slate-400/30",
  SUSPENDED: "bg-amber-500/15 text-amber-400 border-amber-500/30",
  ARCHIVED: "bg-rose-500/15 text-rose-400 border-rose-500/30",
};

export function TenantStatusBadge({ status, size = "md" }) {
  const s = (status || "").toUpperCase();
  const style = STATUS_STYLE[s] || "bg-white/10 text-white/60 border-white/10";
  const px = size === "sm" ? "px-2 py-0.5 text-[10px]" : "px-2.5 py-1 text-[11px]";
  return (
    <span
      data-testid={`tenant-status-badge-${s.toLowerCase()}`}
      className={`inline-flex items-center gap-1 rounded-full border font-black uppercase tracking-wider ${px} ${style}`}
    >
      {s || "—"}
    </span>
  );
}

const PACKAGE_STYLE = {
  STARTER: "bg-sky-500/15 text-sky-300 border-sky-500/30",
  GROWTH: "bg-violet-500/15 text-violet-300 border-violet-500/30",
  ENTERPRISE: "bg-amber-500/15 text-amber-300 border-amber-500/30",
};

export function TenantPackageBadge({ package: pkg, size = "md" }) {
  const p = (pkg || "").toUpperCase();
  const style = PACKAGE_STYLE[p] || "bg-white/10 text-white/60 border-white/10";
  const px = size === "sm" ? "px-2 py-0.5 text-[10px]" : "px-2.5 py-1 text-[11px]";
  return (
    <span
      data-testid={`tenant-package-badge-${p.toLowerCase()}`}
      className={`inline-flex items-center rounded-full border font-black uppercase tracking-wider ${px} ${style}`}
    >
      {p || "—"}
    </span>
  );
}
